module.exports = __webpack_public_path__ + "img/tomato_amazake.cfbc8682.jpg";